import { render, staticRenderFns } from "./file-tab.vue?vue&type=template&id=ca724580&scoped=true"
import script from "./file-tab.vue?vue&type=script&lang=js"
export * from "./file-tab.vue?vue&type=script&lang=js"
import style0 from "./file-tab.vue?vue&type=style&index=0&id=ca724580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca724580",
  null
  
)

export default component.exports